import {
    COMMON_LEGAL_DATA,
    COMMON_STEP_FIELDS,
    EMPTY_PERSONAL_DATA,
} from '../../data-layer/partner/constants';
import {
    DocumentTypeEnum,
    FormTypeEnum,
    type IERegistrationModel,
    type LLCRegistrationModel,
    type PartnerBankDetailsModel,
    type PartnerSignerDataModel,
    type SERegistrationModel,
    SignupExternalPartnership,
} from '../../data-layer/partner/types';

export const toSelfEmployedDto = (model: SERegistrationModel): SignupExternalPartnership => ({
    ...COMMON_STEP_FIELDS,
    form_type: FormTypeEnum.SELF_EMPLOYED,
    personal_data: {
        ...EMPTY_PERSONAL_DATA,
        first_name: model.firstName,
        last_name: model.lastName,
        patronym: model.patronymic,
        birth_date: model.birthDate,
        pass_number: model.passport,
        issue_date: model.issuedDate,
        issuer_code: model.subdivisionCode,
        issued_by: model.issuedBy,
        legal_address: model.registrationAddress,
        legal_address_postcode: model.index,
        snils: model.snilsNumber,
    },
});

export const toIndividualEntrepreneurDto = (
    model: IERegistrationModel,
): SignupExternalPartnership => ({
    ...COMMON_STEP_FIELDS,
    form_type: FormTypeEnum.LEGAL_ENTITY,
    legal_data: {
        ...COMMON_LEGAL_DATA,
        ogrn_or_inn: model.innOgrn,
        legal_address: model.registrationAddress,
        legal_address_postcode: model.index,
        legal_form: 4,
    },
});

export const toLLCDto = (model: LLCRegistrationModel): SignupExternalPartnership => ({
    ...COMMON_STEP_FIELDS,
    form_type: FormTypeEnum.LEGAL_ENTITY,
    legal_data: {
        ...COMMON_LEGAL_DATA,
        ogrn_or_inn: model.innOgrn,
        legal_form: 1,
    },
});

export const toBankDetailsDto = (model: PartnerBankDetailsModel, correspondentAccount: string) => ({
    ...COMMON_STEP_FIELDS,
    bic: model.bik,
    account_nr: model.accountNumber,
    bank_name: model.bankName,
    correspondent_account_nr: correspondentAccount,
    actual_address_same: true,
});

export const toSignerDataDto = (model: PartnerSignerDataModel) => ({
    ...COMMON_STEP_FIELDS,
    position: model.position,
    full_name: model.fullName,
    document_type: DocumentTypeEnum.CHARTER,
    document_scan_key: null,
});
